// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3LY0w","buttons":"Footer_buttons__27L99"};